export const iconFontAwesomeWeatherCloudRain = (
	<i className="fa-solid fa-cloud-rain"></i>
);
